/**
 * Same rule as loadBlockingHubNativeReceipts: a failed receipt blocks another
 * receive only while Megaventory work order id is still set. Cleanup can cancel
 * the Megaventory document, null the id, and leave the work order number for history.
 */
export interface HubNativeReceiptBlockRow {
  id: number | string;
  status?: string | null;
  mv_work_order_id?: number | string | null;
  mv_work_order_no?: string | null;
}

export function hubNativeReceiptBlocksFurtherReceive(receipt: HubNativeReceiptBlockRow): boolean {
  const status = (receipt.status ?? "").trim().toLowerCase();
  if (status === "pending_mv") return true;
  if (status !== "failed") return false;
  const workOrderId = receipt.mv_work_order_id;
  if (workOrderId == null) return false;
  if (typeof workOrderId === "string" && workOrderId.trim() === "") return false;
  const numeric = Number(workOrderId);
  return Number.isFinite(numeric) && numeric > 0;
}

export function hubNativeReceiveBlockedReason(
  receipts: HubNativeReceiptBlockRow[],
): string | null {
  const blocking = receipts.filter(hubNativeReceiptBlocksFurtherReceive);
  if (blocking.length === 0) return null;
  const labels = blocking
    .map((receipt) => {
      const number = receipt.mv_work_order_no != null ? String(receipt.mv_work_order_no).trim() : "";
      return number !== "" ? number : `#${String(receipt.id)}`;
    })
    .join(", ");
  return (
    `A previous receive created Megaventory work order ${labels} but did not finish posting. ` +
    `Repair that receipt before receiving again.`
  );
}
